import React from "react";
import { getUser } from "../../Utils/Common";
import { useNavigate } from "react-router-dom";

import "./style.css";

function CancelConfirm(props) {
  const user = getUser();
  console.log(user.name);
  const navigate = useNavigate();
  const closeButton = () => {
    navigate("/account");
    // var closebtns = document.getElementsByClassName("close");
    // var i;

    // closebtns.addEventListener("click", function () {
    //   this.parentElement.style.display = "none";
    // });

    // for (i = 0; i < closebtns.length; i++) {
    //   closebtns[i].addEventListener("click", function () {
    //     this.parentElement.style.display = "none";
    //   });
    // }
    console.log("click me");
  };
  return (
    <div className="container-fluid" style={{ marginTop: "140px" }}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>Account of {user.name} </h1>
          </div>
        </div>
        <div className="row mt-8">
          {/* <div className="col-12"> */}
          <div className="col-1">
            {" "}
            <i className="bi bi-exclamation fs-3hx"></i>
          </div>
          <div className="col-11">
            <ul className="cancel-ul">
              <li className="cancel-li">
                We are sorry to see you leave <br />
                Your subscription has been cancelled{" "}
                <span className="close" onClick={() => closeButton()}>
                  &times;
                </span>
              </li>
            </ul>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default CancelConfirm;
